import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 活动页信息接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122814100
export const voteInfo = createAsyncThunk(
  'bigr_voting_competion_info',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/bigr_voting_competion_info', {
      ...store.getState().env.deviceinfo,
      ...p,
      act_no: 'turkey_misc_act',
    })
    return resp.data?.data
  }
)

// 排行榜数据接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122814252
export const voteRank = createAsyncThunk(
  'bigr_voting_competion_rank_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/bigr_voting_competion_rank_list',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        act_no: 'turkey_misc_act',
      }
    )
    return resp.data?.data
  }
)

// 参赛用户搜索接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122814230
export const searchUser = createAsyncThunk(
  'bigr_voting_competion_search_user',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/bigr_voting_competion_search_user',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        act_no: 'turkey_misc_act',
      }
    )
    return resp.data?.data
  }
)

// 投票接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122814290
export const voteUser = createAsyncThunk(
  'bigr_voting_competion_vote',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/bigr_voting_competion_vote', {
      ...store.getState().env.deviceinfo,
      ...p,
      act_no: 'turkey_misc_act',
    })
    return resp.data?.data
  }
)

export enum STAGESTATUS {
  未开始 = 1,
  开始 = 2,
  已结束 = 3,
}

const initialState: {
  home_page_info?: {
    stage_id?: number
    status?: STAGESTATUS
    start_time?: string
    end_time?: string
    recommendation_list?: {
      id: number
      name: string
      zy_id: string
      avatar: string
      gender: number
    }[] // 保送名单
    prize_list?: {
      id: number
      activity_id: number
      view_icon: string
      toast_name: string
      reward_type: number
      reward_string: string
      count: number
    }[][] // 奖励列表
    user_data?: {
      tickets: number // （用户票数）
      is_participant: boolean // （是否本阶段的参赛者）
      is_today_first_login: boolean // （是否当天首次登录）
      rank_info: {
        data: number // （当前用户距离上一名的分数）
      }
    }
    countdown?: number
  }
} = {
  // home_page_info: {
  //   stage_id: 1,
  //   status: STAGESTATUS.已结束,
  //   start_time: '2022-09-10',
  //   end_time: '2022-09-10',
  //   prize_list: [
  //     [
  //       {
  //         id: 1,
  //         activity_id: 1,
  //         view_icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //         toast_name: 'string',
  //         reward_type: 1,
  //         reward_string: 'string',
  //         count: 10,
  //       },
  //     ],
  //     [
  //       {
  //         id: 1,
  //         activity_id: 1,
  //         view_icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //         toast_name: 'string',
  //         reward_type: 1,
  //         reward_string: 'string',
  //         count: 10,
  //       },
  //       {
  //         id: 1,
  //         activity_id: 1,
  //         view_icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //         toast_name: 'string',
  //         reward_type: 1,
  //         reward_string: 'string',
  //         count: 10,
  //       },
  //       {
  //         id: 1,
  //         activity_id: 1,
  //         view_icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //         toast_name: 'string',
  //         reward_type: 1,
  //         reward_string: 'string',
  //         count: 10,
  //       },
  //       {
  //         id: 1,
  //         activity_id: 1,
  //         view_icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //         toast_name: 'string',
  //         reward_type: 1,
  //         reward_string: 'string',
  //         count: 10,
  //       },
  //       {
  //         id: 1,
  //         activity_id: 1,
  //         view_icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //         toast_name: 'string',
  //         reward_type: 1,
  //         reward_string: 'string',
  //         count: 10,
  //       },
  //       {
  //         id: 1,
  //         activity_id: 1,
  //         view_icon: 'http://img01.mehiya.com/img/png/id/138835740718',
  //         toast_name: 'string',
  //         reward_type: 1,
  //         reward_string: 'string',
  //         count: 10,
  //       },
  //     ],
  //   ], // 奖励列表
  //   user_data: {
  //     tickets: 1, // （用户票数）
  //     is_participant: true, // （是否本阶段的参赛者）
  //     is_today_first_login: false, // （是否当天首次登录）
  //     rank_info: {
  //       data: 10, // （当前用户距离上一名的分数）
  //     },
  //   },
  //   countdown: 600,
  // },
  home_page_info: {},
}

export const TrMusicSlice = createSlice({
  name: 'TrMusic',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(voteInfo.fulfilled, (state, action) => {
      Object.assign(state?.home_page_info, action.payload)
    })
  },
})

export default TrMusicSlice.reducer
export const TrMusicSliceActions = TrMusicSlice.actions
